// ABOUTME: Result modal shown after processing Bol return lines when some returns were skipped.
// ABOUTME: Lists each skipped return with its missing products and required/handled amounts.
import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../theme";
import SHModal from "../../theme/Modal/SHModal";
import Subheading from "../../theme/text/Subheading";
import Text from "../../theme/text/Text";

const MReturnLinesSkipped = (props) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t } = useTranslation();

    const skipped = props.skipped ?? [];

    return (
        <SHModal
            open={props.open}
            onClose={props.handleClose}
        >
            <Box
                sx={{
                    textAlign: "center",
                    paddingY: 4,
                    paddingX: 3,
                    pb: 3,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 1,
                }}
            >
                <Subheading>{props.title ?? t('return_lines_skipped_title', { defaultValue: 'Sommige retouren zijn overgeslagen' })}</Subheading>
                <Text light>
                    {t('return_lines_skipped_description', { defaultValue: 'Deze retouren konden niet volledig verwerkt worden omdat er producten ontbreken.' })}
                </Text>
            </Box>

            <Box
                sx={{
                    background: theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                    padding: 3,
                    borderRadius: 4,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    maxHeight: 400,
                    overflowY: 'auto',
                }}
            >
                {skipped.map((item) => (
                    <Box
                        key={item.returnId}
                        sx={{
                            background: theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100],
                            borderRadius: 4,
                            padding: 2,
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 1,
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                            }}
                        >
                            <Text bold>{item.reference}</Text>
                            <Text light fontSize={13}>{item.parentSku} — {item.parentDescription}</Text>
                        </Box>

                        {(item.missingProducts ?? []).map((product) => (
                            <Box
                                key={product.sku}
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    gap: 2,
                                    background: theme.palette.mode === "dark" ? colors.grey[200] : colors.grey[0],
                                    borderRadius: 4,
                                    px: 2,
                                    py: 1,
                                }}
                            >
                                <Box sx={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                                    <Text semibold noBreak>{product.sku}</Text>
                                    <Text light fontSize={13}>{product.description}</Text>
                                </Box>
                                <Box
                                    sx={{
                                        flexShrink: 0,
                                        background: colors.red[400],
                                        color: theme.palette.mode === "dark" ? colors.txt['primaryDark'] : colors.txt['light'],
                                        fontSize: 14,
                                        fontWeight: "bold",
                                        px: 2,
                                        height: 24,
                                        borderRadius: 4,
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    {product.handledAmount} / {product.requiredAmount}
                                </Box>
                            </Box>
                        ))}
                    </Box>
                ))}
            </Box>
        </SHModal>
    );
};

export default MReturnLinesSkipped;
